import React from 'react';
import { graphql, useFragment } from 'react-relay';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import type { async_softwareReleasesVersionDetail_AsyncEditableName$key } from '@atlassian/jira-relay/src/__generated__/async_softwareReleasesVersionDetail_AsyncEditableName.graphql';
import { lazy } from '@atlassian/react-loosely-lazy';
import { PageTitle } from '../../../common/ui/header/styled.tsx';
import { InlineEditReadViewContainer } from '../../../common/ui/inline-edit-read-view-container/styled.tsx';
import type { EditableName } from './index.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const LazyEditableName = lazy<typeof EditableName>(() =>
	import(/* webpackChunkName: "async-editable-name" */ './index').then(
		(module) => module.EditableName,
	),
);

type Props = {
	isEditing: boolean;
	setIsEditing: (arg1: boolean) => void;
	jiraVersion: async_softwareReleasesVersionDetail_AsyncEditableName$key;
};

export const AsyncEditableName = ({ jiraVersion, isEditing, setIsEditing }: Props) => {
	const version = useFragment(
		graphql`
			fragment async_softwareReleasesVersionDetail_AsyncEditableName on JiraVersion {
				name
				...editableName_softwareReleasesVersionDetail
			}
		`,
		jiraVersion,
	);

	return (
		<Placeholder
			name="editable-name"
			fallback={
				<InlineEditReadViewContainer>
					<PageTitle size="large" as="h1">
						{version.name}
					</PageTitle>
				</InlineEditReadViewContainer>
			}
		>
			<LazyEditableName jiraVersion={version} isEditing={isEditing} setIsEditing={setIsEditing} />
		</Placeholder>
	);
};
